import React, { useState, useEffect } from 'react'
import { ProductApi } from '../../../common/services'

interface renderImageModalProps {
  id: number
}

const renderImageModal = ({ id }: renderImageModalProps): JSX.Element => {
  const [imageUrl, setImageUrl] = useState<string | null>(null)
  useEffect(() => {
    void fetchImage(id ?? 0)
  }, [id])

  const fetchImage = async (id: number): Promise<void> => {
    try {
      const response = await new ProductApi().apiV2ProductDownloadIdGet(id) as any
      // Kiểm tra nếu response.error có dữ liệu base64
      if (response.data.data != null) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        setImageUrl(`data:image/png;base64,${response?.data.data}`)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  return (imageUrl != null)
    ? (
      <img
        style={{
          margin: '10px',
          border: 'none'
        }}
        className="imgHarness"
        src={imageUrl}
        alt={'image'}
      />
      )
    : (
      <div style={{ width: 150, height: 150, backgroundColor: 'rgb(246 246 246)', marginTop: 10, marginBottom: 10 }} />
      )
}

export default renderImageModal
